import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaResumoPrestacaoRecursoRecebidoInicio: [],
    buscaResumoPrestacaoRecursoRecebidoSucesso: ['resumoPrestacaoRecursoRecebido'],
    buscaResumoPrestacaoRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaResumoPrestacaoRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaResumoPrestacaoRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarResumoPrestacao(filtro)
            .then(response => dispatch(Creators.buscaResumoPrestacaoRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaResumoPrestacaoRecursoRecebidoErro(error)))
    }
}

const buscaResumoPrestacaoRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaResumoPrestacaoRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaResumoPrestacaoRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.resumoPrestacaoRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_RESUMO_PRESTACAO_RECURSO_RECEBIDO_INICIO]: buscaResumoPrestacaoRecursoRecebidoInicio,
    [Types.BUSCA_RESUMO_PRESTACAO_RECURSO_RECEBIDO_ERRO]: buscaResumoPrestacaoRecursoRecebidoErro,
    [Types.BUSCA_RESUMO_PRESTACAO_RECURSO_RECEBIDO_SUCESSO]: buscaResumoPrestacaoRecursoRecebidoSucesso,
})
